import client from "../api/client";
export const getList = () => {
  return client('/api/building-stat-types').then(({ data }) => data.data);
};

export const getDetail = (id) => {
  return client(`/api/building-stat-types/${id}`).then(({ data }) => data.data);
};

export const addEditModel = (values= {}, id=null) => {
  if (id){
    return client(`/api/building-stat-types/${id}`, {method: 'put', body: values}).then(({ data }) => data.data);
  } else {
    return client('/api/building-stat-types', {method: 'post', body: values}).then(({ data }) => data.data);
  }
};

export const delModel = (id) => {
    return client(`/api/building-stat-types/${id}`, {method: 'delete'}).then(({ data }) => data.data);
};

export function useBuildingStatTypeService () {
  return {
    getList,
    addEditModel,
    getDetail,
    delModel,
  };
}
